/* Buy-box accordions: reconnect safely after Shopify section rendering. */
if (!customElements.get("cstm-buy-box-actions")) {
  customElements.define("cstm-buy-box-actions", class extends HTMLElement {
    connectedCallback() {
      if (this.handleClick) return;
      this.handleClick = (event) => {
        const trigger = event.target.closest("[data-action-trigger]");
        const close = event.target.closest("[data-action-close]");
        if (trigger && this.contains(trigger)) {
          const panel = this.getPanel(trigger.dataset.actionTrigger);
          if (panel) this.setOpen(trigger.dataset.actionTrigger, panel.hidden);
        } else if (close && this.contains(close)) {
          const panel = close.closest("[data-action-panel]");
          if (panel) this.closePanel(panel);
        }
      };
      this.handleKeydown = (event) => {
        if (event.key !== "Escape") return;
        const panel = Array.from(this.querySelectorAll("[data-action-panel]")).find((item) => !item.hidden);
        if (panel) { event.preventDefault(); this.closePanel(panel); }
      };
      this.addEventListener("click", this.handleClick);
      this.addEventListener("keydown", this.handleKeydown);
      const posted = new URLSearchParams(window.location.search).get("contact_posted") === "true";
      this.querySelectorAll("[data-action-panel]").forEach((panel) => {
        if (panel.querySelector(".form-status-success, .form-status-error") || (posted && panel.querySelector(".form-status"))) {
          this.setOpen(panel.dataset.actionPanel, true);
        }
      });
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
      this.removeEventListener("keydown", this.handleKeydown);
      this.handleClick = null;
    }

    getPanel(key) {
      return Array.from(this.querySelectorAll("[data-action-panel]")).find((panel) => panel.dataset.actionPanel === key);
    }

    closePanel(panel) {
      const key = panel.dataset.actionPanel;
      this.setOpen(key, false);
      Array.from(this.querySelectorAll("[data-action-trigger]")).find((trigger) => trigger.dataset.actionTrigger === key)?.focus();
    }

    setOpen(key, open) {
      this.querySelectorAll("[data-action-panel]").forEach((panel) => {
        const active = open && panel.dataset.actionPanel === key;
        panel.hidden = !active;
        if (active && panel.dataset.actionPanel === "calendly") this.loadCalendly(panel);
      });
      this.querySelectorAll("[data-action-trigger]").forEach((trigger) => {
        trigger.setAttribute("aria-expanded", String(open && trigger.dataset.actionTrigger === key));
      });
    }

    loadCalendly(panel) {
      const container = panel.querySelector("[data-calendly-container]");
      if (!container || container.querySelector("iframe")) return;
      let url;
      try { url = new URL(panel.dataset.calendlyUrl); } catch { return; }
      if (url.protocol !== "https:" || !["calendly.com", "www.calendly.com"].includes(url.hostname) || url.username || url.password || url.port) return;
      const frame = document.createElement("iframe");
      frame.title = "Beratungstermin bei Calendly auswählen";
      frame.src = url.href;
      frame.referrerPolicy = "strict-origin-when-cross-origin";
      container.appendChild(frame);
    }
  });
}
